var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0833 12.9168H1.91667C1.41066 12.9168 1 12.5061 1 12.0001C1 11.4941 1.41066 11.0834 1.91667 11.0834H22.0833C22.5893 11.0834 23 11.4941 23 12.0001C23 12.5061 22.5893 12.9168 22.0833 12.9168Z",
    fill: "#989899"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0833 5.88894H1.91667C1.41066 5.88894 1 5.47827 1 4.97227C1 4.46627 1.41066 4.0556 1.91667 4.0556H22.0833C22.5893 4.0556 23 4.46627 23 4.97227C23 5.47827 22.5893 5.88894 22.0833 5.88894Z",
    fill: "#989899"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0833 19.9444H1.91667C1.41066 19.9444 1 19.5338 1 19.0278C1 18.5217 1.41066 18.1111 1.91667 18.1111H22.0833C22.5893 18.1111 23 18.5217 23 19.0278C23 19.5338 22.5893 19.9444 22.0833 19.9444Z",
    fill: "#989899"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.eb933b686aeea51b92663c37f35a245c.svg";
export { ForwardRef as ReactComponent };